module.exports = __webpack_public_path__ + "static/media/lk-old-galle-buck.270a2747.png";